import { notification } from 'antd';
import actions from './actions';
import { DataService } from '../../../config/dataService/dataService';

const GENERIC_API_ERROR = process.env.REACT_APP_GENERIC_ERROR_MESSAGE;

const {
  claveDescuentoList,
  claveDescuentoListSelectBox,
  claveDescuentoCreate,
  claveDescuentoRead,
  claveDescuentoUpdate,
  claveDescuentoDelete,  
} = actions;

const claveDescuentoListAction = (paramBusqueda = '') => {
  return async dispatch => {
    try {
      const response = await DataService.get('/claveDescuento/list.php?paramBusqueda=' + paramBusqueda);      
      
      if (response.status === 200 && response.data.data) {       
        dispatch(claveDescuentoList(response.data.data));
        return true
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};


const claveDescuentoCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/claveDescuento/manage.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const claveDescuentoReadAction = (id = '') => {
  return async dispatch => {
    try {
      if (id != '') {
        const response = await DataService.get('/claveDescuento/manage.php?id=' + id);
        if (response.status === 200 && response.data.data) {
          dispatch(claveDescuentoRead(response.data.data));
          return true;
        }
      } else {
        dispatch(claveDescuentoRead({}));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

/////////////////

export {
  claveDescuentoListAction,
  claveDescuentoCreateAction,
  claveDescuentoReadAction,    
};
